import { EventMapping } from '@scale/shared/types/events';
import { MatchesSchema } from '@scale/shared/types/analytics/MatchesSchema';
import { logEvent } from '@scale/frontend-lib/events';

export async function logCorpEvent<
  E extends keyof EventMapping,
  T extends MatchesSchema<EventMapping[E], T>,
>(eventType: E, event: T) {
  Object.assign(event as any, { corp: true });
  // @ts-ignore
  return logEvent(eventType, event).catch(() => {}); // Catch errors
}
